var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEbp2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "matrix(1 0 0 -1 0 32.5)",
    fill: "url(#paint0_linear_5700_816)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6218 24.834V22.1887L16.2111 16.962C16.6093 16.5922 16.9009 16.2651 17.0858 15.9807C17.2849 15.6962 17.4129 15.4402 17.4698 15.2127C17.5409 14.9709 17.5764 14.7504 17.5764 14.5513C17.5764 14.0678 17.4129 13.6909 17.0858 13.4207C16.7729 13.1504 16.2964 13.0153 15.6564 13.0153C15.116 13.0153 14.6111 13.1362 14.1418 13.378C13.6724 13.6198 13.2884 13.9824 12.9898 14.466L9.85377 12.7167C10.4084 11.778 11.212 11.0242 12.2644 10.4553C13.3169 9.88643 14.5755 9.60198 16.0404 9.60198C17.1924 9.60198 18.2022 9.78687 19.0698 10.1567C19.9373 10.5264 20.6129 11.0526 21.0964 11.7353C21.5942 12.418 21.8431 13.2215 21.8431 14.146C21.8431 14.6295 21.7791 15.1131 21.6511 15.5967C21.5231 16.066 21.2742 16.5709 20.9044 17.1113C20.5489 17.6375 20.0155 18.2278 19.3044 18.882L14.8671 22.978L14.1631 21.4847H22.2484V24.834H10.6218Z",
    fill: "#FEFEFE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5700_816",
    x1: 16,
    y1: 24.6667,
    x2: 16,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2CD3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#597B13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEbp2);
export default __webpack_public_path__ + "static/media/ebp-2.95ff424b7c4add5ff03f63eb588df303.svg";
export { ForwardRef as ReactComponent };